import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { HookTrackRetentionCard } from '../HookTrackRetentionCard';

interface VideoData {
  id: string;
  name: string;
  isMain?: boolean;
}

interface RetentionTabContentProps {
  videos: VideoData[];
  retentionData: any[];
  winnerVideoId: string | null;
  winnerVideoName?: string;
  hasData: boolean;
  maxVideoDuration?: number;
}

export function RetentionTabContent({
  videos,
  retentionData,
  winnerVideoId,
  winnerVideoName,
  hasData,
  maxVideoDuration
}: RetentionTabContentProps) {
  useLanguage();
  return (
    <div className="space-y-6">
      {/* Container Premium com Borda + Shadow */}
      <div 
        className="bg-white rounded-[16px] p-8 border border-[#E5E7EB]"
        style={{
          boxShadow: '0px 6px 18px rgba(0, 0, 0, 0.035)',
        }}
      >
        {/* Header interno */}
        <div className="mb-6">
          <h2 className="text-[20px] font-semibold text-foreground mb-1">
            {translateInterfaceText("Retenção ao longo do tempo")}</h2>
          <p className="text-sm text-[#6B7280]">
            {translateInterfaceText("Visualize como a retenção evoluiu entre as diferentes introduções testadas.")}</p>
        </div>

        {/* Linha divisória */}
        <div className="border-b border-[#EEF2F6] mb-6" />

        {/* Retention Chart Premium */}
        <HookTrackRetentionCard
          videos={videos}
          retentionData={retentionData}
          winnerVideoId={winnerVideoId}
          hasData={hasData}
          maxVideoDuration={maxVideoDuration}
        />
        
      </div>
    </div>
  );
}
